import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@ohif/ui';

// Route Components
import PatientList from "../../../custom/Patients/patientlist"
import ReportList from "../../../custom/Reports/reportlist"
import RollbackList from '../../../custom/Reports/rollBack/RollbackList';
import DataSourceWrapper from './DataSourceWrapper';
import WorkList from './WorkList';
import Local from './Local';
import Debug from './Debug';
import NotFound from './NotFound';
import buildModeRoutes from './buildModeRoutes';
import PrivateRoute from './PrivateRoute';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReportTemplateList from "../../../custom/Reports/ReportTemplateList"
import Login from '@custom/Auth/login';
import ResetPassword from "../../../custom/Auth/resetPassword";
import Dashboard from "../../../custom/Dashboard/Dashboard";
import Hospital from "../../../custom/Hospital"
import Teleradiology from '@custom/Teleradiology/teleradiology';
import Addteleradiology from '@custom/Teleradiology/addteleradiologycus';
import AddEditHospital from "../../../custom/Hospital/addEdithospital"
import Users from "../../../custom/Users"
import Appointments from "../../../custom/Appointments"
import AddEditUser from "../../../custom/Users/addEditUser"
import AddEditAppointments from "../../../custom/Appointments/addEditAppointments"
import PatientRegistration from "../../../custom/Patients/PatientRegistration"
import { isValidUser } from "../../../custom/Utils/authUtils";
import { _routes } from '@custom/Utils/constants/routes';
import PreviewReport from '@custom/Reports/Preview';
import PreviewAppointments from '@custom/Appointments/Preview';
import PatientDetail from '@custom/Patients/PatientDetail/PatientDetail';
import ForgotPassword from '../../../custom/Auth/forgotPassword';
import EmailVerification from '../../../custom/Auth/emailVerification';
import path from 'path';
import SendToMachine from '@custom/SendToMachine/SendToMachine';
import Profile from '../../../custom/Profile';
import UserDetails from '../../../custom/Users/userDetails';
import Audit from "../../../custom/Audit/index"
import Pacs from '@custom/Pacs';
import AddEditPacs from '@custom/Pacs/addEditPacs';
import AddEditMachines from '@custom/Machines/addEditMachines';
import Machines from '@custom/Machines';
import { ReportsSettings } from '@custom/index';
import RollbackPreview from '@custom/Reports/rollBack/rollbackPreview/rollbackPreview';
import Teleradiologist from '@custom/Teleradiologist';
import AddEditRadiologist from '@custom/Teleradiologist/addEditTeleradiologist';
import StudyList from '@custom/StudyList';
import FrontdeskMachines from '../../../custom/activeMachine/machineType';
import AddEditActivemachine from '@custom/activeMachine/addeditfrontmachine';
import StudyResearch from '@custom/StudyResearch/StudyResearch';
import MyworkList from '@custom/myworklist/myworkList';
import HospitalAnalytics from '@custom/Hospital/HospitalAnalytics/HospitalAnalytics';
import TeleUserDetails from '@custom/Teleradiologist/teleUserDetails';
import TeleUserProfile from '@custom/TeleUserProfile';
import SharedReport from '@custom/Reports/sharedReportPreview';
import Microscopy from '@custom/Microscopy/index';
import Pricing from '@custom/Pricing';
import AddEditPricing from '@custom/Pricing/addEditPricing';
import CreateReport from '@custom/Reports/CreateReport';
import Analytics from '@custom/Analytics';
import LabStudies from '@custom/LabStudies';
import QualityIndicators from '@custom/QualityIndicators';
import Billing from '@custom/Billing';
import Investigation from '@custom/Investigation';
import AddEditInvestigation from '@custom/Investigation/addEditInvestigation';
import BillingInvoice from '@custom/BillingInvoice';
import PreviewInvoice from '@custom/BillingInvoice/InvoicePreview';
import CaseTimingSettings from '@custom/Settings/CaseTimingSettings';
import BillingAudit from '@custom/Audit/billingAuditlog';
import TeleradiologistAuditLogs from '@custom/Audit/TeleradiologistAuditogs';
import ModalityPricing from '@custom/Settings/ModalityPricing';
import AddEditModalityPricing from '@custom/Settings/ModalityPricing/addEditModalityPricing';
import TeleradiologistPayouts from '@custom/TeleradiologistPayouts';
import myProfileHospital from '@custom/Hospital/myProfile';
import TeleServicePrice from '@custom/Settings/teleServicePrice';
import PricingSettings from '@custom/Settings/Pricing';
import DiscountNotification from '@custom/DiscountNotification';
import AddEditCaseToCase from '@custom/Settings/Pricing/AddEditCreditForCaseToCase';
import AddOnsForm from '@custom/Settings/Pricing/AddOnsForm';
import CaseCredit from '@custom/CaseCredit/CaseCreditComponent'
import ExtraStorageForm from '@custom/Settings/Pricing/ExtraStorageForm';

const NotFoundServer = ({
  message = 'Unable to query for studies at this time. Check your data source configuration or network connection',
}) => {
  return (
    <div className="absolute flex h-full w-full items-center justify-center text-white">
      <div>
        <h4>{message}</h4>
      </div>
    </div>
  );
};

const ShareLinkExpired = () => {

  const message = 'The link has expired. Please contact the administrator for assistance.'
  return (
    <div className="absolute flex h-full w-full items-center justify-center bg-black text-white">
      <div>
        <h4>{message}</h4>
      </div>
    </div>
  );
};

const AccessDenied = () => {

  const navigate = useNavigate();

  const message = 'Access to this study is restricted. Please contact the administrator for assistance or consider upgrading your plan to gain access.'
  return (
    <div className="absolute flex h-full w-full items-center justify-center bg-black text-white">
      <div className="flex flex-col gap-4 justify-center items-center">
        <h4>{message}</h4>

        <button className="flex items-center gap-2 bg-teal-600 text-white font-medium py-1.5 px-4 rounded-full hover:bg-teal-700" onClick={() => navigate('/')}> Go to Studylist page </button>
      </div>
    </div>
  );
};


NotFoundServer.propTypes = {
  message: PropTypes.string,
};

const NotFoundStudy = () => {
  return (
    <div className="absolute flex h-full w-full bg-black items-center justify-center text-white">
      <div>
        <h4>
          One or more of the requested studies are not available at this time. Return to the{' '}
          <Link
            className="text-primary-light"
            to={'/'}
          >
            study list
          </Link>{' '}
          to select a different study to view.
        </h4>
      </div>
    </div>
  );
};

NotFoundStudy.propTypes = {
  message: PropTypes.string,
};

const PatientListComponent = () => <PatientList />;
const ReportTemplateListComponent = () => <ReportTemplateList />
const ReportListComponent = () => <ReportList />
const HospitalPage = () => <Hospital />
const TeleradiologyPage = () => <Teleradiology />
const AddTeleraidologyPage = () => <Addteleradiology />
const TeleradiologistPage = () => <Teleradiologist />
const AddTeleraidologistPage = () => <AddEditRadiologist />
const AddEditHospitalPage = () => <AddEditHospital />
const UserList = () => <Users />
const AddEditUserPage = () => <AddEditUser />
const appointmentList = () => <Appointments />
const addEditAppointmentPage = () => <AddEditAppointments />
const PatientRegistrationComponent = () => <PatientRegistration />
const myProfile = () => <Profile />
const userProfile = () => <TeleUserProfile />
const UserDetailsPage = () => <UserDetails />
const TeleUserDetailsPage = () => <TeleUserDetails />
const RollbackListComponent = () => <RollbackList />
const PacsList = () => <Pacs />
const AddEditPacsComponent = () => <AddEditPacs />
const AddEditMachineComponent = () => <AddEditMachines />
const MachinesList = () => <Machines />
const RollbackPreviewComponent = () => <RollbackPreview />
const FrontdeskMachinesComponent = () => <FrontdeskMachines />
const AddEditActivemachineComponent = () => <AddEditActivemachine />
const MyworkListComponent = () => <MyworkList />
const HospitalAnalyticsComponent = () => <HospitalAnalytics />
const PricingPage = () => <Pricing />
const AddEditPricingPage = () => <AddEditPricing />
const InvestigationPage = () => <Investigation />
const AddEditInvestigationPage = () => <AddEditInvestigation />
const AnalyticsPage = () => <Analytics />
const LabStudiesPage = () => <LabStudies />
const QualityIndicatorsPage = () => <QualityIndicators />
const CaseTimingSettingsPage = () => <CaseTimingSettings />
const billingAudit = () => <BillingAudit />
const TeleradiologistAuditLogsPage = () => <TeleradiologistAuditLogs />
const ModalityPricingPage = () => <ModalityPricing />
const AddEditModalityPricingPage = () => <AddEditModalityPricing />
const TeleradiologistPayoutsPage = () => <TeleradiologistPayouts />
const TeleServicePricePage = () => <TeleServicePrice />
const PricingSettingsPage = () => <PricingSettings />
const AddEditCreditForCaseToCasePage = () => <AddEditCaseToCase />
const AddOnsFormPage = () => <AddOnsForm />
const CaseCreditPage = () => <CaseCredit />
const AddEditExtraStoragePage = () => <ExtraStorageForm />

// TODO: Include "routes" debug route if dev build
const bakedInRoutes = [
  {
    path:'/accessDenied',
    children: AccessDenied
  },
  {
    path: '/shareLinkExpired',
    children: ShareLinkExpired
  },
  {
    path: '/notfoundserver',
    children: NotFoundServer,
  },
  {
    path: '/notfoundstudy',
    children: NotFoundStudy,
  },
  {
    path: '/debug',
    children: Debug,
  },
  {
    path: '/local',
    children: Local.bind(null, { modePath: '' }), // navigate to the worklist
  },
  {
    path: '/localbasic',
    children: Local.bind(null, { modePath: 'viewer/dicomlocal' }),
  },
  {
    path: "/patientlist",
    children: PatientListComponent
  },
  {
    path: '/frontdeskmachine',
    children: FrontdeskMachinesComponent
  },
  {
    path: '/addeditactivemachine',
    children: AddEditActivemachineComponent
  },
  {
    path: "/templatelist",
    children: ReportTemplateListComponent
  },
  {
    path: '/dashboard',
    children: Dashboard,
    props: useNavigate
  },
  {
    path: '/CaseCredit',
    children: CaseCreditPage,
    props: useNavigate
  },
  {
    path: "/patientlist",
    children: PatientListComponent
  },
  {
    path: '/resetPassword',
    children: ResetPassword
  },
  {
    path: '/hospital',
    children: HospitalPage
  },
  {
    path: '/teleradiology',
    children: TeleradiologyPage
  },
  {
    path: '/addTeleradiology',
    children: AddTeleraidologyPage
  },
  {
    path: '/addTeleradiologycustomer',
    children: AddTeleraidologyPage
  },
  {
    path: '/editTeleradiology',
    children: AddTeleraidologyPage
  },
  {
    path: '/teleradiologist',
    children: TeleradiologistPage
  },
  {
    path: '/addTeleradiologist',
    children: AddTeleraidologistPage
  },
  // {
  //   path: '/studyList',
  //   children: StudyLists
  // },
  {
    path: '/addhospital',
    children: AddEditHospitalPage
  },
  {
    path: '/users',
    children: UserList
  },
  {
    path: '/addUser',
    children: AddEditUserPage
  },
  {
    path: '/appointments',
    children: appointmentList
  },

  // Madan
  {
    path: _routes.report.preview,
    children: PreviewReport
  },
  {
    path: '/addappointment',
    children: addEditAppointmentPage
  },
  {
    path: "/addPatient",
    children: PatientRegistrationComponent
  },
  {
    path: "/reportlist",
    children: ReportListComponent
  },
  {
    path: _routes.patient.details,
    children: PatientDetail
  },
  {
    path: _routes.hospital.analytics,
    children: HospitalAnalyticsComponent
  },
  {
    path: _routes.appointments.preview,
    children: PreviewAppointments
  },
  {
    path: _routes.billing.previewInvoice,
    children: PreviewInvoice
  },
  {
    path: _routes.billing.editInvoice,
    children: PreviewInvoice
  },
  {
    path: _routes.billing.cancelInvoice,
    children: PreviewInvoice
  },
  {
    path: _routes.billing.refundInvoice,
    children: PreviewInvoice
  },
  {
    path: '/sendtoMachine',
    children: SendToMachine
  },
  {
    path: _routes.profile.myProfile,
    children: myProfile
  },
  {
    path: _routes.userProfile.myProfile,
    children: userProfile
  },
  {
    path: _routes.user.details,
    children: UserDetailsPage
  },
  {
    path: _routes.teleUser.details,
    children: TeleUserDetailsPage
  },
  {
    path: _routes.audit.list,
    children: Audit
  },
  {
    path: _routes.audit.billing,
    children: billingAudit
  },
  {
    path: _routes.audit.teleradiologist,
    children: TeleradiologistAuditLogsPage
  },
  {
    path: _routes.billing.list,
    children: Billing
  },
  {
    path: _routes.billing.invoice,
    children: BillingInvoice
  },
  {
    path: _routes.investigation.edit,
    children: AddEditInvestigationPage
  },
  {
    path: '/edithospital',
    children: AddEditHospitalPage
  },
  {
    path: '/myprofile',
    children: myProfileHospital
  },
  {
    path: '/pacs',
    children: PacsList
  },
  {
    path: '/price',
    children: PricingPage
  },
  {
    path: '/investigation',
    children: InvestigationPage
  },
  {
    path: '/addpacs',
    children: AddEditPacsComponent
  },
  {
    path: '/addprice',
    children: AddEditPricingPage
  },
  {
    path: '/addmachines',
    children: AddEditMachineComponent
  },
  {
    path: '/machines',
    children: MachinesList
  },
  {
    path: _routes.settings.reports,
    children: ReportsSettings
  },
  // {
  //   path: _routes.settings.machines,
  //   children: MachinesSettings
  // },
  // {
  //   path: _routes.settings.pacs,
  //   children: PACSSettings
  // },
  {
    path: _routes.settings.caseTiming,
    children: CaseTimingSettingsPage
  },
  {
    path: '/studyResearch',
    children: StudyResearch
  },
  {
    path: "/reportlist",
    children: ReportListComponent
  },
  {
    path: "/myworklist",
    children: MyworkListComponent
  },
  {
    path: "/rollbacklist",
    children: RollbackListComponent
  },
  {
    path: "/rollbackpreview/:id",
    children: RollbackPreviewComponent
  },
  {
    path: "/WSI/:uhid/:id",
    children: Microscopy
  },
  {
    path: "/createReport",
    children: CreateReport
  },
  {
    path: "/analytics",
    children: AnalyticsPage
  },
  {
    path: "/lab-studies",
    children: LabStudiesPage,
  },
  {
    path: "/qualityIndicators",
    children: QualityIndicatorsPage
  },
  {
    path: _routes.settings.modalityPrice,
    children: ModalityPricingPage
  },
  {
    path: _routes.settings.addEditModalityPricing,
    children: AddEditModalityPricingPage
  },
  {
    path: _routes.audit.teleradiologistPayouts,
    children: TeleradiologistPayoutsPage
  },
  {
    path: _routes.settings.teleServicePrice,
    children: TeleServicePricePage
  },
  {
    path: _routes.settings.pricing,
    children: PricingSettingsPage
  },
  {
    path: _routes.billing.discountNoti,
    children: DiscountNotification
  },
  {
    path: _routes.settings.addEditCreditForCaseToCase,
    children: AddEditCreditForCaseToCasePage
  },
  {
    path: _routes.settings.addEditAddOns,
    children: AddOnsFormPage
  },
  {
    path: _routes.settings.addEditExtraStorage,
    children: AddEditExtraStoragePage
  }
];

const unauthorizedRoutes = [
  {
    path: _routes.authentication.resetPassword,
    children: ResetPassword
  },
  {
    path: _routes.authentication.login,
    children: Login,
    prop: useNavigate
  },
  {
    path: _routes.authentication.forgotPassword,
    children: ForgotPassword,
    prop: useNavigate
  },
  {
    path: _routes.authentication.verification,
    children: EmailVerification,
    prop: useNavigate
  },
  {
    path: `/sharedreport/:id`,
    children: SharedReport
  }
];

// NOT FOUND (404)
const notFoundRoute = { component: NotFound };

const ProtectedRoute = ({ element }) => {
  const queryParams = new URLSearchParams(window.location.search);

  // Extract the parameters
  const studyUID = queryParams.get('StudyInstanceUIDs');
  const shareAuthToken = queryParams.get('shareAuthToken');
  const shareDicomToken = queryParams.get('dicomToken');

  if (shareAuthToken) {
    sessionStorage.setItem('shareAuthToken', shareAuthToken)
    console.log('shareAuthToken', shareAuthToken)
  }
  if (shareDicomToken) {
    sessionStorage.setItem('shareDicomToken', shareDicomToken)
    console.log('shareDicomToken', shareDicomToken)
  }

  if (shareAuthToken || sessionStorage.getItem('shareAuthToken')
  ) {
    return element
  } else {
    return isValidUser() ? element : <Navigate to="/login" />;
  }
};

const createRoutes = ({
  modes,
  dataSources,
  extensionManager,
  servicesManager,
  commandsManager,
  hotkeysManager,
  routerBasename,
  showStudyList,
  showStudyListRoute,
}: withAppTypes) => {
  const routes =
    buildModeRoutes({
      modes,
      dataSources,
      extensionManager,
      servicesManager,
      commandsManager,
      hotkeysManager,
    }) || [];

  const { customizationService } = servicesManager.services;

  // WorkList Route definition
  const WorkListRoute = {
    path: '/',
    children: DataSourceWrapper,
    private: true,
    props: { children: WorkList, servicesManager, extensionManager },
  };

  const customRoutes = customizationService.getGlobalCustomization('customRoutes');
  const allRoutes = [
    ...routes,
    ...(showStudyList ? [WorkListRoute] : []),
    ...(customRoutes?.routes || []),
    ...bakedInRoutes,
    customRoutes?.notFoundRoute || notFoundRoute,
  ];

  function RouteWithErrorBoundary({ route, ...rest }) {

    const location = useLocation();

    useEffect(() => {
      if (location.pathname === '/' || location.pathname.startsWith('/invoice/preview/') || location.pathname.startsWith('/invoice/edit/') || location.pathname.startsWith('/invoice/cancel/') || location.pathname.startsWith('/report/preview/') || location.pathname.startsWith('/appointments/preview/')) {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
          metaViewport.setAttribute('content', 'width=1500');
        }
      } else {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
          metaViewport.setAttribute('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=0');
        }
      }
    }, [location.pathname]);

    return (
      <ErrorBoundary context={`Route ${route.path}`} fallbackRoute="/">
        <route.children
          {...rest}
          {...route.props}
          route={route}
          servicesManager={servicesManager}
          extensionManager={extensionManager}
          hotkeysManager={hotkeysManager}
        />
      </ErrorBoundary>
    );
  }

  const { userAuthenticationService } = servicesManager.services;

  return (
    <Routes>
      {unauthorizedRoutes.map((route, i) => (
        <Route key={i} path={route.path} element={<RouteWithErrorBoundary route={route} />} />
      ))}
      {allRoutes.map((route, i) => (
        route.private === true ? (
          <Route
            key={i}
            exact
            path={route.path}
            element={
              <PrivateRoute handleUnauthenticated={() => userAuthenticationService.handleUnauthenticated()}>
                <ProtectedRoute element={<RouteWithErrorBoundary route={route} />} />
              </PrivateRoute>
            }
          />
        ) : (
          <Route
            key={i}
            path={route.path}
            element={<ProtectedRoute element={<RouteWithErrorBoundary route={route} />} />}
          />
        )
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default createRoutes;
